<template>
  <div class="pocAiClass">
    <div class="pac_head">
      <div class="pac_h_left">
        <!-- <span>八年级</span>><span>上学期</span>><span>{{
          editionList[edition]
        }}</span> -->
        <span>筛选</span>
      </div>
      <div class="pac_h_right">
        <div class="p_h_r_box">
          <div>
            <div>
              <el-image
                class="p_h_r_b_avatar"
                :src="
                  require('../../../assets/icon/pocAiClassroom/defaultAvatar.png')
                "
              ></el-image>

              <span>{{ userInfo.userName }}</span>
            </div>
            <span @click.stop="settings()">
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M1.07817 8.26844C0.973943 8.10465 0.973943 7.89535 1.07817 7.73156L4.57817 2.23156C4.66995 2.08734 4.82905 2 5 2L11 2C11.1709 2 11.3301 2.08734 11.4218 2.23156L14.9218 7.73156C15.0261 7.89535 15.0261 8.10465 14.9218 8.26844L11.4218 13.7684C11.3301 13.9127 11.1709 14 11 14L5 14C4.82905 14 4.66995 13.9127 4.57817 13.7684L1.07817 8.26844ZM5.27447 13L10.7255 13L13.9073 8L10.7255 3L5.27447 3L2.09265 8L5.27447 13Z"
                  fill="black"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M8 6.5C7.17157 6.5 6.5 7.17157 6.5 8C6.5 8.82843 7.17157 9.5 8 9.5C8.82843 9.5 9.5 8.82843 9.5 8C9.5 7.17157 8.82843 6.5 8 6.5ZM5.5 8C5.5 6.61929 6.61929 5.5 8 5.5C9.38071 5.5 10.5 6.61929 10.5 8C10.5 9.38071 9.38071 10.5 8 10.5C6.61929 10.5 5.5 9.38071 5.5 8Z"
                  fill="black"
                />
              </svg>
            </span>
          </div>
          <div>
            <div class="pac_h_r_b_grade">
              <div>{{ gradeList[userInfo.grade] }}</div>
              <span @click.stop="changeGrade()"
                ><svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M13.3333 9.52856L10.1953 12.6666L9.25229 11.7239L10.1143 10.8622L2.39062 10.8619V9.52856H13.3333ZM5.52862 3.52856L6.47129 4.47123L5.60929 5.33323H13.3333V6.66656H2.39062L5.52862 3.52856Z"
                    fill="black"
                    fill-opacity="0.6"
                  />
                </svg>
              </span>
            </div>
          </div>
        </div>
        <!-- <span @click.stop="changeGrade()">切换年级</span>
        <el-image
          class="pac_h_r_avatar"
          :src="require('../../../assets/icon/pocAiClassroom/avatar.svg')"
        ></el-image> -->
      </div>
    </div>

    <div class="pac_screen">
      <el-select
        v-model="subject"
        class="pac_s_select"
        size="medium"
        placeholder="请选择学科"
      >
        <el-option label="全部学科" value=""></el-option>
        <el-option
          v-for="(item, index) in subjectList"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>

      <el-select
        v-model="edition"
        class="pac_s_select"
        size="medium"
        placeholder="请选择版本"
      >
        <el-option label="全部版本" value=""></el-option>
        <el-option
          v-for="(item, index) in editionList"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>

      <el-input placeholder="搜索" v-model="searchValue" class="pac_s_select">
        <i
          slot="suffix"
          @click.stop="search()"
          style="cursor: pointer;"
          class="el-input__icon el-icon-search"
        ></i>
      </el-input>

			<span class="pac_s_reset" @click.stop="reset()">重置</span>
    </div>
    <!-- <div class="pac_subjectList">
      <span
        :class="[subject == index ? 'pac_sl_active' : '']"
        v-for="(item, index) in subjectList"
        :key="index"
        @click.stop="changeSubject(index)"
        >{{ item }}</span
      >
    </div> -->

    <!-- <div class="pac_editionList">
      <span
        :class="[edition == index ? 'pac_el_active' : '']"
        v-for="(item, index) in editionList"
        :key="index"
        @click.stop="changeEdition(index)"
        >{{ item }}</span
      >
    </div> -->

    <div class="pac_box" v-if="subject==='' || subject===4">
      <chapterCard
        v-for="(item, index) in classList"
        :key="index"
        :data="item"
				:index="index"
        :subjectList="subjectList"
      />
    </div>

    <div class="pac_footDialog" v-if="showDialog">
      <div class="pac_fd_closeArea"></div>
      <div class="pac_fd_bottom">
        <div class="pac_fd_b_left">
          <img
            :src="
              characterList.find(i => userInfo.choseCharacter === i.index).image
            "
          />
        </div>
        <div class="pac_fd_b_right">
          <span class="pac_fd_b_r_characterName">{{
            characterList.find(i=>userInfo.choseCharacter===i.index)?characterList.find(i=>userInfo.choseCharacter===i.index).name:'AI'
          }}</span>
          <span class="pac_fd_b_r_closeIcon" @click.stop="showDialog = false">  
            <svg
              width="14"
              height="14" 
              viewBox="0 0 14 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M7 0C3.14049 0 0 3.14001 0 7C0 10.86 3.14001 14 7 14C10.8595 14 14 10.86 14 7C14 3.14001 10.86 0 7 0ZM9.8555 9.156C10.0505 9.352 10.05 9.668 9.85451 9.863C9.75702 9.96 9.62951 10.009 9.50152 10.009C9.37301 10.009 9.24502 9.96001 9.14751 9.86201L6.9975 7.7055L4.84051 9.83951C4.74302 9.93552 4.61599 9.98401 4.48899 9.98401C4.36001 9.98401 4.2315 9.9345 4.1335 9.83551C3.9395 9.639 3.941 9.32299 4.13751 9.1285L6.292 6.9975L4.14549 4.844C3.95049 4.64849 3.951 4.332 4.14649 4.137C4.342 3.94149 4.65798 3.94251 4.85349 4.13799L7.00298 6.29399L9.15998 4.16001C9.35597 3.96552 9.67297 3.9675 9.86698 4.16401C10.0615 4.36052 10.0595 4.67701 9.86298 4.87101L7.70851 7.00199L9.8555 9.156Z"
                fill="#E0EAFB"
              />
            </svg>
          </span>
          <div class="pac_fd_b_r_message">
            Hi，{{
              userInfo.userName
            }}同学，欢迎回来！你是否开始下一节课的学习，学习<span>【水循环】</span>？
          </div>
          <div class="pac_fd_b_r_btnArea">
            <span class="pac_fd_b_r_ba_btn1" @click.stop="dialogBtn(3)"
              >我想聊聊天</span
            >
            <span class="pac_fd_b_r_ba_btn2" @click.stop="dialogBtn(2)"
              >我想复习上一节课</span
            >
            <span class="pac_fd_b_r_ba_btn3" @click.stop="dialogBtn(1)"
              >好，开始学习新内容→</span
            >
          </div>
        </div>
      </div>
      <!-- <div class="pac_fd_left">
        <el-image
          class="pac_fd_l_hello"
          :src="require('../../../assets/icon/pocAiClassroom/hello.gif')"
        ></el-image>
      </div>
      <div class="pac_fd_right">
        <div class="pac_fd_r_messageArea">
          <div class="pac_fd_r_ma_message">
            Hi，科科同学，欢迎回来！你是否开始下一课的学习，学习【运动的快慢】？
          </div>
          <div class="pac_fd_r_ma_btnArea">
            <span @click.stop="dialogBtn(1)">好,开始学习新内容</span>
            <span @click.stop="dialogBtn(2)">我想复习上一节课</span>
            <span @click.stop="dialogBtn(3)">我想聊聊天</span>
          </div>
          <span class="pac_fd_r_ma_closeIcon" @click.stop="dialogBtn(0)"
            >×</span
          >
        </div>
      </div> -->
    </div>
		<settingsDialog ref="settingsDialogRef" :gradeList="gradeList" :characterList="characterList" @changeUserInfo="changeUserInfo" @changeCharacterInfo="changeCharacterInfo"/>
  </div>
</template>

<script>
import chapterCard from "./component/chapterCard.vue";
import settingsDialog from "./component/settingsDialog.vue";
export default {
  components: {
    chapterCard,
		settingsDialog
  },
  data() {
    return {
      userId: this.$route.query.userid,
      org: this.$route.query.org,
      oid: this.$route.query.oid,
      subject: 4,
      edition: 0,
      searchValue: "",
      grade: 7,
	
      showDialog: true,
      userInfo: {
        userName: "科科",
				grade:6,
				userAvatar:"",
        choseCharacter: 0,
      },
      characterList: [
        {
          index: 0,
          image: require("../../../assets/icon/pocAiClassroom/character1.png"),
					name:"圆鼓鼓的大胖鱼",
					personality:"心思细腻，能够敏锐捕捉到别人的需求，喜欢支持和鼓励他人，富有耐心",  
        },
        {
          index: 1,
          image: require("../../../assets/icon/pocAiClassroom/character2.png"),
					name:"迷人的大反派2",
					personality:"心思细腻，能够敏锐捕捉到别人的需求，喜欢支持和鼓励他人，富有耐心2",  
        },
        {
          index: 2,
          image: require("../../../assets/icon/pocAiClassroom/character3.png"),
					name:"迷人的大反派3",
					personality:"心思细腻，能够敏锐捕捉到别人的需求，喜欢支持和鼓励他人，富有耐心3",  
        },
        {
          index: 3,
          image: require("../../../assets/icon/pocAiClassroom/character4.png"),
					name:"迷人的大反派4",
					personality:"心思细腻，能够敏锐捕捉到别人的需求，喜欢支持和鼓励他人，富有耐心4",  
        },
        {
          index: 4,
          image: require("../../../assets/icon/pocAiClassroom/character5.png"),
					name:"迷人的大反派5",
					personality:"心思细腻，能够敏锐捕捉到别人的需求，喜欢支持和鼓励他人，富有耐心5",  
        },
        {
          index: 5,
          image: require("../../../assets/icon/pocAiClassroom/character6.png"),
					name:"迷人的大反派6",
					personality:"心思细腻，能够敏锐捕捉到别人的需求，喜欢支持和鼓励他人，富有耐心6",  
        }
      ],
			gradeList: ['小一', '小二', '小三', '小四', '小五', '小六', '中一', '中二', '中三','中四','中五','中六'],
      subjectList: [
        // { value: 0, label: '语文' },
        // { value: 1, label: '数学' },
        // { value: 2, label: '英语' },
        // { value: 3, label: '物理' },
        // { value: 4, label: '化学' },
        // { value: 5, label: '生物' },
        // { value: 6, label: '历史' },
        // { value: 7, label: '地理' },
        // { value: 8, label: '政治' }
				{ value: 0, label: '中國語文' },
        { value: 1, label: '英國語文 ' },
        { value: 2, label: '數學' },
        { value: 3, label: '公民與社會發展' },
        { value: 4, label: '科學' },
        { value: 5, label: '物理' },
        { value: 6, label: '化學' },
        { value: 7, label: '生物' },
        { value: 8, label: '中國歷史' }
      ],
      // gradeList: [
      //   "一年级",
      //   "二年级",
      //   "三年级",
      //   "四年级",
      //   "五年级",
      //   "六年级",
      //   "七年级",
      //   "八年级",
      //   "九年级"
      // ],
      // subjectList: [
      //   { value: 0, label: "语文" },
      //   { value: 1, label: "数学" },
      //   { value: 2, label: "英语" },
      //   { value: 3, label: "物理" },
      //   { value: 4, label: "化学" },
      //   { value: 5, label: "生物" },
      //   { value: 6, label: "历史" },
      //   { value: 7, label: "地理" },
      //   { value: 8, label: "政治" }
      // ],
      editionList: [
				{ value: 0, label: "牛津大學" },
        // { value: 0, label: "人教版" },
        // { value: 1, label: "教科版" },
        // { value: 2, label: "北师大版" },
        // { value: 3, label: "苏教版" },
        // { value: 4, label: "沪教版" },
        // { value: 5, label: "浙教版" },
        // { value: 6, label: "冀教版" },
        // { value: 7, label: "鲁教版" },
        // { value: 8, label: "人教A版" },
        // { value: 9, label: "人教B版" }
      ],
      classList: [
        {
          title: '第一章：科學入門',
          allClass: [
            {
              title: '學習科學',
              type: 0,
              isComplete: true,
              subject: 4,
              image: 'https://ccrb.s3.cn-northwest-1.amazonaws.com.cn/%E5%9B%BE%E7%89%8741724834676182.png'
            },
            {
              title: '科學的實踐',
              type: 0,
              subject: 4,
              isComplete: true,
              image: 'https://ccrb.s3.cn-northwest-1.amazonaws.com.cn/%E5%9B%BE%E7%89%8731724834767532.png'
            },
            {
              title: '實驗室安全',
              type: 0,
              subject: 4,
              isComplete: false,
              image: 'https://ccrb.s3.cn-northwest-1.amazonaws.com.cn/%E5%9B%BE%E7%89%8721724834685472.png'
            },
            {
              title: '實驗室儀器及基本實驗技巧',
              type: 0,
              subject: 4,
              isComplete: false,
              image: 'https://ccrb.s3.cn-northwest-1.amazonaws.com.cn/%E5%9B%BE%E7%89%8751724834771676.png'
            },
            {
              title: '綜合練習',
              type: 1,
              subject: 4,
              isComplete: false,
              image: 'https://ccrb.s3.cn-northwest-1.amazonaws.com.cn/%E5%9B%BE%E7%89%8711724834666052.png'
            }
          ]
        },
        {
          title: '第二章：水',
          allClass: [
            {
              title: '水的物熊變化',
              type: 0,
              subject: 4,
              isComplete: true,
              image: 'https://ccrb.s3.cn-northwest-1.amazonaws.com.cn/%E5%9B%BE%E7%89%8761724834777931.png'
            },
            {
              title: '水循環',
              type: 0,
              subject: 4,
              isComplete: true,
              image: 'https://ccrb.s3.cn-northwest-1.amazonaws.com.cn/%E5%9B%BE%E7%89%8771724834845597.png'
            },
            {
              title: '溶解',
              type: 0,
              subject: 4,
              isComplete: true,
              image: 'https://ccrb.s3.cn-northwest-1.amazonaws.com.cn/%E5%9B%BE%E7%89%8781724834847977.png'
            },
            {
              title: '水的淨化',
              type: 0,
              subject: 4,
              isComplete: true,
              image: 'https://ccrb.s3.cn-northwest-1.amazonaws.com.cn/%E5%9B%BE%E7%89%8791724834873373.png'
            },
            {
              title: '食水的進一步處理',
              type: 0,
              subject: 4,
              isComplete: false,
              image: 'https://ccrb.s3.cn-northwest-1.amazonaws.com.cn/%E5%9B%BE%E7%89%8761724834777931.png'
            },
            {
              title: '節約用水和水污染',
              type: 0,
              subject: 4,
              isComplete: false,
              image: 'https://ccrb.s3.cn-northwest-1.amazonaws.com.cn/%E5%9B%BE%E7%89%8771724834845597.png'
            },
            {
              title: '綜合練習',
              type: 1,
              subject: 4,
              isComplete: false,
              image: 'https://ccrb.s3.cn-northwest-1.amazonaws.com.cn/%E5%9B%BE%E7%89%8721724834685472.png'
            },
          ]
        },
        {
          title: '第三章：观察生物',
          allClass: [
            {
              title: '生物',
              type: 0,
              isComplete: true,
              subject: 4,
              image: 'https://ccrb.s3.cn-northwest-1.amazonaws.com.cn/%E5%9B%BE%E7%89%8741724834676182.png'
            },
            {
              title: '生物的分類',
              type: 0,
              subject: 4,
              isComplete: true,
              image: 'https://ccrb.s3.cn-northwest-1.amazonaws.com.cn/%E5%9B%BE%E7%89%8731724834767532.png'
            },
            {
              title: '檢索表',
              type: 0,
              subject: 4,
              isComplete: false,
              image: 'https://ccrb.s3.cn-northwest-1.amazonaws.com.cn/%E5%9B%BE%E7%89%8721724834685472.png'
            },
            {
              title: '生物多樣性',
              type: 0,
              subject: 4,
              isComplete: false,
              image: 'https://ccrb.s3.cn-northwest-1.amazonaws.com.cn/%E5%9B%BE%E7%89%8751724834771676.png'
            },
            {
              title: '綜合練習',
              type: 1,
              subject: 4,
              isComplete: false,
              image: 'https://ccrb.s3.cn-northwest-1.amazonaws.com.cn/%E5%9B%BE%E7%89%8711724834666052.png'
            }
          ]
        }
      ]
    };
  },
  methods: {
    changeGrade() {
      this.$refs.settingsDialogRef.open(this.userInfo);
    },
    // changeSubject(newIndex) {
    //   if (this.subject == newIndex) return;
    //   this.subject = newIndex;
    // },
    // changeEdition(newIndex) {
    //   if (this.edition == newIndex) return;
    //   this.edition = newIndex;
    // },
    dialogBtn(type = 0) {
      if (type == 0) {
        this.showDialog = false;
      } else if (type == 1) {
        this.$router.push(
          `/pocClass?userid=${this.userId}&org=${this.org}&oid=${this.oid}&type=1`
        );
        // console.log("开始学习新的内容");
      } else if (type == 2) {
        this.$router.push(
          `/pocClass?userid=${this.userId}&org=${this.org}&oid=${this.oid}&type=2`
        );
        // console.log("复习上一节课");
      } else if (type == 3) {
        this.$router.push(
          `/pocAiChat?userid=${this.userId}&org=${this.org}&oid=${this.oid}&type=3`
        );
      }
    },
		reset(){
			this.subject="";
      this.edition="";
      this.searchValue="";
		},
    settings() {
      this.$refs.settingsDialogRef.open(this.userInfo);
    },
    search() {
      console.log("搜索", this.searchValue);
    },
		changeUserInfo(data){
			this.userInfo.userName = data.userName;
			this.userInfo.grade = data.grade;
			this.$refs.settingsDialogRef.close();
		},
		changeCharacterInfo(data){
			this.userInfo.choseCharacter = data.index;
			this.$refs.settingsDialogRef.close();
		}
  },
  mounted() {}
};
</script>

<style scoped>
.pocAiClass {
  width: 100vw;
  height: 100vh;
  overflow: auto;
  /* background-image: radial-gradient(#bbcdff 0%, #bbcdff 1%, #e6dee9 100%); */
  background-color: #f0f2f5;
  box-sizing: border-box;
  padding: 0 100px;
}

.pac_head {
  width: 100%;
  height: auto;
  margin-top: 30px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
}

.pac_h_left {
  width: auto;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.pac_h_left > span {
  font-size: 28px;
}

.pac_h_right {
  width: auto;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.p_h_r_box {
  width: auto;
  height: auto;
  background-color: #fff;
  border: 1px solid #e0eafb;
  border-radius: 8px;
}

.p_h_r_box > div {
  width: 200px;
  height: 50px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 10px;
  box-sizing: border-box;
}

.p_h_r_box > div > div {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.p_h_r_box > div > div > span {
  font-size: 20px;
  margin-left: 10px;
  display: block;
  max-width: 100px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.p_h_r_box > div > span {
  width: 20px;
  height: 20px;
}

.p_h_r_box > div > span > svg {
  width: 100%;
  height: 100%;
  cursor: pointer;
}

.p_h_r_b_avatar {
  min-width: 40px;
  min-height: 40px;
  width: 40px;
  height: 40px;
}

.pac_h_r_b_grade {
  width: 100%;
  height: 60%;
  border-radius: 4px;
  padding: 2px 8px 2px 8px;
  display: flex;
  justify-content: space-between !important;
  background-color: #f0f2f5;
}

.pac_h_r_b_grade > span {
  text-align: right;
  width: 20px;
  height: 20px;
}

.pac_h_r_b_grade > span > svg {
  width: 100%;
  height: 100%;
  cursor: pointer;
}

/* .pac_h_right > span {
  padding: 8px 12px;
  background-color: #d9d9d9;
  border: solid 1px #fff;
  font-size: 18px;
  border-radius: 8px;
  margin-right: 20px;
  cursor: pointer;
} */

.pac_h_r_avatar {
  width: 50px;
  height: 50px;
}

/* .pac_subjectList {
  max-width: 100%;
  height: 50px;
  overflow: auto;
  display: flex;
  align-items: center;
  margin-top: 20px;
}

.pac_subjectList > span {
  width: auto;
  height: 100%;
  margin-right: 20px;
  font-size: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: relative;
  transition: all 0.3s;
  white-space: nowrap;
}

.pac_sl_active {
  color: #4874cb;
}

.pac_sl_active::after {
  content: "";
  width: 100%;
  height: 5px;
  border-radius: 5px;
  background-color: #4874cb;
  position: absolute;
  bottom: 0px;
  left: 0;
}

.pac_subjectList > span:hover {
  color: #4874cb;
}

.pac_editionList {
  max-width: 100%;
  height: 50px;
  overflow: auto;
  display: flex;
  align-items: center;
  margin-top: 20px;
}

.pac_editionList > span {
  padding: 7px 12px;
  background-color: #f2f2f2;
  border-radius: 10px;
  font-size: 20px;
  margin-right: 20px;
  cursor: pointer;
  transition: all 0.1s;
  border: solid 1px #f2f2f2;
  white-space: nowrap;
}

.pac_el_active {
  background-color: #4874cb !important;
  color: #fff;
  border: solid 1px #2e54a1 !important;
} */

.pac_screen {
  width: 100%;
  height: 60px;
  margin-top: 0px;
  display: flex;
  align-items: center;
}

.pac_s_reset{
	padding: 10px 15px;
	background-color: #E2EEFF;
	color: #3681FC;
	font-size: 20px;
	border-radius: 8px;
	cursor: pointer;
}

.pac_s_select {
  width: 230px;
  height: 40px;
  margin-right: 30px;
}

.pac_s_select >>> .el-input {
  width: 100%;
  height: 100%;
  font-size: 16px;
}

.pac_s_select >>> .el-input > .el-input__inner {
  width: 100%;
  height: 100%;
}

.pac_s_select >>> .el-input__inner {
  font-size: 16px;
}

.pac_box {
  width: 100%;
  height: auto;
  margin-top: 20px;
}

.pac_fd_left {
  width: 200px;
  height: 200px;
}

.pac_fd_l_hello {
  width: 100%;
  height: 100%;
}

.pac_fd_right {
  flex: 1;
  height: 200px;
  display: flex;
  align-items: center;
}

.pac_fd_r_messageArea {
  width: 100%;
  height: 90%;
  background-color: #dae3f5;
  box-sizing: border-box;
  padding: 30px 30px 20px 30px;
  border: solid 3px #fff;
  border-radius: 0 20px 0 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
}
.pac_fd_r_ma_message {
  width: 100%;
  flex: 1;
  font-size: 26px;
}

.pac_fd_r_ma_btnArea {
  width: 100%;
  height: 50px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.pac_fd_r_ma_btnArea > span {
  margin-left: 30px;
  background-color: #fff;
  padding: 14px 20px;
  border-radius: 10px;
  cursor: pointer;
  border: solid 2px #4874cb;
}

.pac_fd_r_ma_btnArea > span:nth-of-type(1) {
  background-color: #4874cb;
  color: #fff;
}

.pac_fd_r_ma_closeIcon {
  font-size: 30px;
  font-weight: bold;
  position: absolute;
  right: 10px;
  top: 10px;
  cursor: pointer;
  color: #fff;
}

.pac_footDialog {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  /* background-color: red; */
}

.pac_fd_closeArea {
  width: 100%;
  height: 100%;
  background: linear-gradient(
    180deg,
    rgba(32, 51, 80, 0) 0%,
    rgba(73, 116, 182, 0.6) 100%
  );
}

.pac_fd_bottom {
  width: 70%;
  min-width: 1000px;
  height: 220px;
  position: absolute;
  bottom: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.pac_fd_b_left {
  width: 130px;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  z-index: 1;
}

.pac_fd_b_left > img {
  position: absolute;
  bottom: -40px;
  width: 700px;
  transform: translate(70px, 57px);
}

.pac_fd_b_right {
  flex: 1;
  height: 100%;
  background: linear-gradient(180deg, #fafcff 0%, #e7eefe 100%);
  border-radius: 6px;
  padding: 32px 24px 24px 24px;
  box-sizing: border-box;
  z-index: 2;
  position: relative;
}

.pac_fd_b_r_characterName {
  padding: 10px 15px;
  background-color: #3681fc;
  border-radius: 6px;
  color: white;
  font-weight: bold;
  font-size: 20px;
  position: absolute;
  left: -20px;
  top: -20px;
}

.pac_fd_b_r_closeIcon{
	width: 25px;
	height: 25px;
	position: absolute;
	right: 10px;
	top: 10px;
}

.pac_fd_b_r_closeIcon>svg{
	width: 100%;
	height: 100%;
	cursor: pointer;
}

.pac_fd_b_r_message {
  max-width: 100%;
  font-size: 24px;
  padding: 30px 30px;
}

.pac_fd_b_r_message > span {
  font-weight: bold;
}

.pac_fd_b_r_btnArea {
  position: absolute;
  bottom: 30px;
  right: 30px;
  width: 100%;
  height: auto;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.pac_fd_b_r_btnArea > span {
  padding: 12px 30px;
  border-radius: 6px;
  font-size: 18px;
  cursor: pointer;
  margin-left: 20px;
  cursor: pointer;
  background-color: #fdfeff;
  box-sizing: border-box;
}

.pac_fd_b_r_ba_btn1 {
  color: #00000099;
}

.pac_fd_b_r_ba_btn2 {
  border: 2px solid #3681fc;
  background-color: #ffffffe5 !important;
}

.pac_fd_b_r_ba_btn3 {
  background-color: #3681fc !important;
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/pocAiClassroom/index.vue